import React from 'react';
import { Platform, Pressable, StyleSheet } from 'react-native';
import { IconButton } from 'react-native-paper';
import { Colors } from '../../themes/colors';
import { useRoleHex } from '../../themes/useRoleHex';

type CloseButtonProps = {
  onClose: () => void;
};

export const CloseButton: React.FC<CloseButtonProps> = ({
  onClose,
}: CloseButtonProps) => {
  const size = Platform.select({
    web: 20,
    default: 32,
  });

  const containerColor = Platform.select({
    web: Colors.primary,
    default: Colors.white,
  });

  // Not `Colors.role.textOnBrand`: on web that is a `var()` string, and Paper
  // derives the ripple from `iconColor` via the `color` library
  // (getIconButtonColor -> Color(iconColor).alpha(...)), which throws on a
  // variable and takes the screen down through the error boundary. See
  // `useRoleHex` for the full list of Paper props that parse colours.
  const textOnBrandHex = useRoleHex('textOnBrand');

  const iconColor = Platform.select({
    web: textOnBrandHex,
    default: Colors.primaryDark,
  });

  return (
    <Pressable onPress={onClose}>
      <IconButton
        icon="close"
        mode="contained"
        containerColor={containerColor}
        size={size}
        iconColor={iconColor}
        style={styles.iconClose}
      />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  iconClose: {
    ...Platform.select({
      web: {
        width: 32,
        height: 32,
      },
      default: {
        width: 72,
        height: 72,
        borderRadius: 36,
      },
    }),
  },
});
